import { createValueFormatter, type ServerColDef } from '@cmg/data-grid';

import type { UnderwriterEmployeeFragment } from '../components/SalesCoverageGrid/graphql/__generated__';

export const valueFormatter = createValueFormatter<UnderwriterEmployeeFragment, string>();

const nameColDef: ServerColDef<UnderwriterEmployeeFragment> = {
  field: 'name',
  headerName: 'Name',
  minWidth: 200,
  valueFormatter,
  pinned: 'left',
  filterParams: {
    filterOptions: ['equals', 'notEqual'],
  },
};

export default nameColDef;
